<template>
    <div
        class="logo-wrapper flex"
        :class="{isReduced: isDisplayModeReduced, isMobile: isDisplayMobile, isMounted, isSmall: !isDisplayModeReduced && isSmall}"
    >
        <div class="logo-wrapper-mask">
            <a :href="asideMenuStore.logoNavigationRoute">
                <MaltImg
                    key="expanded"
                    class="logo-wrapper-mask_image"
                    src="/navbar/logos/malt-logo-red.svg?vh=9690b2"
                    width="125"
                    height="35"
                    alt="Malt logo"
                />
            </a>
        </div>
        <button v-if="!isDisplayModeFunnel" type="button" :aria-label="t('navbar.header.menu.close.mobile')" @click="handleCloseMobileNavBar">
            <VJoyIcon v-if="isDisplayMobile" name="cross" size="small" color="neutral" />
        </button>
    </div>
</template>

<script setup lang="ts">
    import {MaltImg} from '#components';
    import {useAsideMenu} from '@navbar-logged/features/aside-menu/aside-menu.store';
    import {storeToRefs} from 'pinia';
    import {useDebounceMount, useDisplayMobile} from '@malt/utils';
    import {useDisplayMode} from '@navbar-logged/features/aside-menu/stores/display-mode.store';
    import {useTranslation} from '#imports';
    import {VJoyIcon} from '@maltjoy/core-vue';

    const {t} = useTranslation();
    const asideMenuStore = useAsideMenu();
    const displayModeStore = useDisplayMode();
    const {isDisplayModeReduced, isDisplayModeFunnel} = storeToRefs(displayModeStore);

    const {isDisplayMobile} = useDisplayMobile();

    defineProps<{
        isSmall?: boolean;
    }>();

    const {isMounted} = useDebounceMount(0, {mode: 'client'});

    function handleCloseMobileNavBar() {
        asideMenuStore.setMobileNavBarOpened(false);
    }
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .logo-wrapper {
        padding: var(--joy-core-spacing-5) var(--joy-core-spacing-5) var(--joy-core-spacing-4) var(--joy-core-spacing-5);
        margin-top: -4px;
        justify-content: space-between;
        align-items: center;

        &.isMounted {
            transition: padding 0.3s ease;
        }

        &-mask {
            width: auto;
            overflow: hidden;
            transition: width 0.3s ease;
            &_image {
                width: 124px;
                max-width: none;
            }
        }

        &.isReduced {
            .logo-wrapper-mask {
                width: 32px;
            }
        }

        &.isSmall {
            .logo-wrapper-mask {
                margin-left: var(--joy-core-spacing-1);

                img {
                    width: 70px;
                    height: 20px;
                }
            }
        }
    }
</style>
